import mountainsbanner from "../assets/mountains.png"

function AbtBanner() {
    return(
        <div id="mountains-banner">
            <img src={mountainsbanner}
                 alt= "image of mountains and a forest"/>
        </div>
    );
}

export default AbtBanner